import { FC } from "react"

import './Footer.scss'

export const Footer: FC = () => {
  return (
    <div className="Footer">
      <div className='Footer__overview'>
          <p>Copyright &copy; TOGCF 2024</p>
      </div>
    </div>
  );
}
